module.exports = __webpack_public_path__ + "img/22.332102ac.jpg";